import { Resource } from './resource';

export class BIDrillResource extends Resource {
  constructor(args: any) {
    super('bidrill', args.resourceId);
  }

  public generateResourceId(encode: boolean): string {
    return encode ? encodeURIComponent(this.resourceId) : this.resourceId;
  }
}
